<script setup>
import AdvancedConversationManager from '@/views/apps/conversation/list/AdvancedConversationManager.vue';

definePage({
  meta: {
    action: 'read',
    subject: 'conversations',
  },
})
</script>

<template>
  <section>
    <AdvancedConversationManager></AdvancedConversationManager>
  </section>
</template>
